import PropTypes from 'prop-types'
import { Text } from '@artprov/design-system'
import { DonutChart } from '../../../common/components/charts/DonutChart'
import { TABLAS_LABELS } from '../../../common/constants/labels'

const CHART_HEIGHT = 456
const CHART_OUTER_RADIUS = 137.5
const CHART_HINT_OFFSET_Y = 40

const LoadingState = () => (
  <div className="relative min-h-[28.5rem]">
    <div className="h-[28.5rem] rounded bg-tertiary-80/20 animate-pulse" />
    <div className="absolute inset-0 flex items-center justify-center rounded-md">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-blue-primary" />
    </div>
  </div>
)

const EmptyState = ({ title }) => (
  <div className="min-h-[28.5rem] flex flex-col items-center justify-center gap-3 rounded-md border border-dashed border-tertiary-80 bg-tertiary-98 px-6 text-center">
    <Text variant="h7" className="text-primary-10 font-semibold">
      {title}
    </Text>
    <Text variant="body2" className="text-tertiary-40">
      <span className="font-bold">Sin datos</span> {TABLAS_LABELS.NO_DATA_PERIOD}
    </Text>
  </div>
)

EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
}

const DonutChartSection = ({ chartConfig, data, isLoading }) => {
  const hasVisibleData = data.some((item) => item.value > 0)
  let content = <EmptyState title={chartConfig.title} />

  if (isLoading) {
    content = <LoadingState />
  } else if (hasVisibleData) {
    content = (
      <DonutChart
        data={data}
        title={chartConfig.title}
        leftHint={chartConfig.leftHint}
        rightHint={chartConfig.rightHint}
        ariaLabel={chartConfig.ariaLabel}
        showBorder={false}
        width="100%"
        minWidth={480}
        height={CHART_HEIGHT}
        outerRadius={CHART_OUTER_RADIUS}
        hintOffsetY={CHART_HINT_OFFSET_Y}
      />
    )
  }

  return <div className="w-full overflow-x-auto">{content}</div>
}

DonutChartSection.propTypes = {
  chartConfig: PropTypes.shape({
    title: PropTypes.string.isRequired,
    leftHint: PropTypes.string.isRequired,
    rightHint: PropTypes.string.isRequired,
    ariaLabel: PropTypes.string.isRequired,
  }).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired,
      selected: PropTypes.bool,
    })
  ).isRequired,
  isLoading: PropTypes.bool,
}

export default DonutChartSection
